import React from 'react';
import { cn } from '../../lib/utils/utils';

const Button = React.forwardRef(
  ({ className, variant = 'default', size = 'default', ...props }, ref) => {
    const variants = {
      default: "bg-primary text-secondary hover:bg-primary/90 font-semibold shadow-sm",
      outline: "border-2 border-slate-200 bg-transparent hover:bg-slate-50 text-secondary font-medium",
      ghost: "hover:bg-slate-100/50 hover:text-primary transition-all",
      destructive: "bg-red-500 text-white hover:bg-red-600",
      secondary: "bg-secondary text-white hover:bg-black font-semibold",
    };

    const sizes = {
      default: "h-11 px-6",
      sm: "h-9 px-4 text-xs",
      lg: "h-14 px-10 text-base",
      icon: "h-10 w-10",
    };

    return (
      <button
        className={cn(
          "inline-flex items-center justify-center rounded-full text-sm transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/20 disabled:pointer-events-none disabled:opacity-50 active:scale-95",
          variants[variant],
          sizes[size],
          className
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Button.displayName = 'Button';

export { Button };
